import React from "react";
import { Col, Row } from "reactstrap";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const Selected = () => {
  const navigate = useNavigate();

  const handleNavigation = (e) => {
    // 1. Obtener y parsear valores de localStorage
    const limit = parseInt(localStorage.getItem("active_offers_limit")) || 0;
    const active = parseInt(localStorage.getItem("active_offers")) || 0;
    const credits = parseInt(localStorage.getItem("available_credits")) || 0;

    const remainingOffers = limit - active;

    // 2. Lógica de validación
    if (remainingOffers <= 0) {
      e.preventDefault();
      toast.error("No hay ofertas restantes disponibles");
      return;
    }

    if (credits <= 0) {
      e.preventDefault();
      toast.error("Considera recargar creditos pronto");
    }

    // 3. Acción exitosa
    localStorage.removeItem("job_id");
    navigate("/bookmarkjobpost");
  };

  return (
    <React.Fragment>
      <Row className="align-items-center" style={{ marginBottom: '20px' }}>
        <Col lg={8}>
          <div className="mb-4 mb-lg-0">
            <h6 className="mb-0"> Mis Ofertas de Empleo </h6>
          </div>
        </Col>
        <Col lg={4}>
          <div className="candidate-list-widgets">
            <Row>
              {/* Usamos un botón con estilo de link para mejor control del evento */}
              <button 
                className="btn btn-primary" 
                onClick={handleNavigation}
                style={{ width: '100%' }}
              >
                Añadir
              </button>
            </Row>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Selected;